/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Influencer202,
  PostApiV1Influencer400,
  PostApiV1Influencer401,
  PostApiV1Influencer500,
  PostApiV1InfluencerMutationRequest,
  PostApiV1InfluencerMutationResponse,
} from "../../types/influencerRegistroController/PostApiV1Influencer.ts";
import { createInfluencerRequestViewModelSchema } from "../createInfluencerRequestViewModelSchema.ts";
import { influencerViewModelSchema } from "../influencerViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Influencer202Schema = z.lazy(
  () => influencerViewModelSchema,
) as unknown as ToZod<PostApiV1Influencer202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Influencer400Schema =
  z.any() as unknown as ToZod<PostApiV1Influencer400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Influencer401Schema =
  z.any() as unknown as ToZod<PostApiV1Influencer401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Influencer500Schema =
  z.any() as unknown as ToZod<PostApiV1Influencer500>;

export const postApiV1InfluencerMutationRequestSchema = z.lazy(
  () => createInfluencerRequestViewModelSchema,
) as unknown as ToZod<PostApiV1InfluencerMutationRequest>;

export const postApiV1InfluencerMutationResponseSchema = z.lazy(
  () => postApiV1Influencer202Schema,
) as unknown as ToZod<PostApiV1InfluencerMutationResponse>;
